import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import get from 'lodash/get';

import BooksCarousel from 'rebook/apps/base/components/BooksCarousel';
import BooksetsCarousel from 'rebook/apps/base/components/BooksetsCarousel';
import CatalogAsideMenu from 'rebook/apps/catalog/components/CatalogAsideMenu';
import Article from 'rebook/apps/base/components/Article';
import TextTruncate from 'rebook/apps/base/components/TextTruncate';
import GenreList from 'rebook/apps/catalog/components/GenreList';
import NicheHeader from 'rebook/apps/catalog/components/NicheHeader';
import * as NicheDetailActions from 'rebook/apps/catalog/actions/NicheDetailActions';

import styles from './style.scss';


class NicheDetailView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(NicheDetailActions.fetchInitialData(match));
  }

  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called server side
    // so we fetch data for client here
    this.props.NicheDetailActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.NicheDetailActions.resetData();
  }

  render() {
    const { niche, genres, books, audiobooks, totalBookCount, booksets } = this.props.nicheDetail;
    const { nicheSlug } = this.props.match.params;
    const audiobookCount = get(audiobooks, 'bookCount');
    const audiobookList = get(audiobooks, 'books');

    const backLink = {
      to: '/catalog/',
      title: 'Библиотека',
    };

    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        <div className="section">
          {niche && (
            <NicheHeader
              title={niche.name}
              bookCount={niche.active_book_count}
              image={niche.image}
              backLink={backLink}
              niche={niche} />
          )}
          <div className={styles.content}>
            {genres && (
              <CatalogAsideMenu
                items={genres}
                extraClassName={styles.asideMenu}
                urlPattern={(url) => (`/catalog/${niche.slug}/${url}/`)} />
            )}
            <div className={styles.rightColumn}>
              <BooksCarousel
                bookList={books}
                bookCount={totalBookCount}
                title="Все книги"
                link={nicheSlug ? `/catalog/${nicheSlug}/books/` : ''} />
              <BooksCarousel
                bookList={audiobookList}
                bookCount={audiobookCount}
                title="Все аудиокниги"
                type="аудио"
                link={{
                  pathname: nicheSlug ? `/catalog/${nicheSlug}/books/audio/` : '',
                  state: { audiobooks },
                }} />
              <div className={styles.list}>
                <GenreList genres={genres} />
              </div>
              {get(booksets, 'length', 0) > 0 && (
                <BooksetsCarousel
                  title={'Подборки'}
                  booksets={booksets} />
              )}
              {niche && (
                <React.Fragment>
                  <h2>О жанре «{niche.name}»</h2>
                  <div className={styles.nicheDescription}>
                    <TextTruncate theme="grey">
                      <Article htmlContent={niche.seo_description || niche.description} />
                    </TextTruncate>
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NicheDetailView.propTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  book_count: PropTypes.number,
  backLink: PropTypes.shape({
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    title: PropTypes.string.isRequired,
  }),
  books: PropTypes.array,
  match: PropTypes.shape({
    params: PropTypes.shape({
      nicheSlug: PropTypes.string.isRequired,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    nicheDetail: state.nicheDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    NicheDetailActions: bindActionCreators(NicheDetailActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NicheDetailView);
